import { useState } from 'react';
import { db } from '../firebase';
import { doc, getDoc, updateDoc } from "firebase/firestore";
import './Section.css';
import { IoSearchSharp, IoClose } from "react-icons/io5";
import { ActionIcon, TextInput, Button, Progress, Textarea, rem } from '@mantine/core';
import { Group, Switch, Table, Text } from '@mantine/core';
import { useInterval } from '@mantine/hooks';
import classes from './CustomSwitch.module.css';
import classes2 from './ButtonProgress.module.css';
import Swal from 'sweetalert2'

import { StyleSheet, View } from 'react-native';
import properties from '../properties.json'
import { TicketCheck, Tickets } from 'lucide-react-native';

function CustomSwitch({ asiste, onChange }: { asiste: boolean, onChange: (val: boolean) => void }) {
    const toggleSwitch = () => {
        const nuevoValor = !asiste;
        onChange(nuevoValor); // Avisamos al padre
    };

    return (
        <Group justify="center" p="md">
            {/* Usamos 'checked' directamente de las props para que sea un componente controlado */}
            <Switch classNames={classes} checked={asiste} onChange={toggleSwitch} />
            <Text>{asiste ? " SI" : " NO"}</Text>
        </Group>
    );
}

function TablaInvitados({ invitados, onToggleInvitado }: { invitados: any[], onToggleInvitado: (index: number, val: boolean) => void }) {
    const rows = invitados.map((invitado, index) => (
        <Table.Tr key={index}>
            <Table.Td w={10}>{invitado.tipo}</Table.Td>
            <Table.Td w={500}>{invitado.nombre}</Table.Td>
            <Table.Td w={100}><CustomSwitch
                asiste={invitado.asiste}
                onChange={(val) => onToggleInvitado(index, val)}
            /></Table.Td>
        </Table.Tr>
    ));

    return (
        <Table>
            <Table.Thead>
                <Table.Tr>
                    <Table.Th w={10}>Tipo</Table.Th>
                    <Table.Th w={500}>Nombre</Table.Th>
                    <Table.Th w={100}>¿Asiste?</Table.Th>
                </Table.Tr>
            </Table.Thead>
            <Table.Tbody>{rows}</Table.Tbody>
        </Table>
    );
}

// --- COMPONENTE PRINCIPAL ---

export function Asistencia() {
    var inputCodigo = document.getElementById("inputCodigo");
    const [isSearching, setIsSearching] = useState(true);
    const [codigoInvitacion, setCodigoInvitacion] = useState('');
    const [mensaje, setMensaje] = useState('');
    const [datos, setDatos] = useState<any>(null);
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const handleToggleInvitado = (index: number, nuevoValor: boolean) => {
        const nuevosInvitados = [...datos.invitados];
        nuevosInvitados[index].asiste = nuevoValor;

        setDatos({
            ...datos,
            invitados: nuevosInvitados
        });
    };
    const Icono = isSearching ? IoSearchSharp : IoClose;
    const obtenerInformacion = async () => {
        if (!codigoInvitacion || !isSearching) {
            setCodigoInvitacion('');
            inputCodigo.disabled = false;
            setIsSearching(true);
            setDatos(null);
            setProgress(0);
            setLoaded(false);
            setError(null);
            return;
        }
        setCargando(true);
        setError(null);
        try {
            const docRef = doc(db, "lista-asistencia", codigoInvitacion);
            const docSnap = await getDoc(docRef);
            if (docSnap.exists()) {
                setDatos(docSnap.data());
                setMensaje(docSnap.data().mensaje);
                inputCodigo.disabled = true;
                setIsSearching(false);
            } else {
                setError("Código no encontrado.");
                setDatos(null);
                inputCodigo.disabled = true;
                setIsSearching(false);
            }
        } catch (err) {
            setError("Error de conexión.");
            inputCodigo.disabled = false;
            setIsSearching(true);
        } finally {
            setCargando(false);
        }
    };

    const actualizaInformacion = async () => {
        setProgress(0);
        if (!codigoInvitacion) {
            setLoaded(false);
            return;
        }
        setCargando(true);
        setError(null);
        try {
            setProgress(25);
            const docRef = doc(db, "lista-asistencia", codigoInvitacion);
            datos.mensaje = mensaje;
            await updateDoc(docRef, datos);
            setProgress(100);
            Swal.fire({
                title: "Cambios Guardados",
                text: "Gracias por tu confirmación.",
                icon: "success",
                confirmButtonColor: properties.detailsColor,
                confirmButtonText: "OK"
            }).then((result) => {
                if (result.isConfirmed) {
                    setCodigoInvitacion('');
                    inputCodigo.disabled = false;
                    setIsSearching(true);
                    setDatos(null);
                    setProgress(0);
                    setLoaded(false);
                }
            });
        } catch (err) {
            setError("Error de conexión.");
            setProgress(0);
            setLoaded(false);
        } finally {
            setCargando(false);
            setProgress(0);
            setLoaded(true);
        }
    }

    const [progress, setProgress] = useState(0);
    const [loaded, setLoaded] = useState(false);

    const interval = useInterval(() => {
        setProgress((current) => {
            if (current < 100) return current + 1;
            interval.stop();
            setLoaded(true);
            return 0;
        });
    }, 20);

    return (
        <div id='sectionConfirmar Asistencia' className='sectionBody'>
            <Tickets size={32} color={properties.detailsColor} />
            <h2 className='title'>Confirma tu Asistencia</h2>
            <div className='line' />
            <View style={styles.form}>
                {/* 1. SE LLAMA COMO COMPONENTE, NO COMO FUNCIÓN */}
                <TextInput
                    styles={{
                        input: {
                            fontSize: rem(16), // Cambia el tamaño aquí
                        }
                    }}
                        id='inputCodigo'
                    radius="xl"
                    placeholder="Ingresa el código de Invitación"
                    value={ codigoInvitacion }
                    onChange={(e) => setCodigoInvitacion(e.target.value)}
                rightSection={
                    <ActionIcon id='botonBuscarBoletos' color={properties.detailsColor} radius="xl" onClick={obtenerInformacion} loading={cargando}>
                        <Icono size={18} />
                    </ActionIcon>
                }
                />

                {error && <p style={{ marginLeft: '12.5%', marginTop: '20px', color: 'red' }}>😟 {error}</p>}

                {datos?.invitados && (
                    <div style={{ marginTop: 20 }}>
                        {/* 2. PASAMOS PROPS CORRECTAMENTE */}
                        <TablaInvitados
                            invitados={datos.invitados}
                            onToggleInvitado={handleToggleInvitado}
                        />
                        <br />
                        <Textarea
                            value={mensaje}
                            onChange={(e) => setMensaje(e.target.value)}
                            label="Mensaje Especial"
                            placeholder="Escribe un mensaje para los novios..." />
                        <br />
                        {/* 3. COMPONENTE CON HOOKS PROPIOS */}
                        <Button
                            id='botonConfirmar'
                            fullWidth
                            className={classes2.button}
                            onClick={actualizaInformacion}
                            color={loaded ? 'teal' : properties.detailsColor}
                            radius="md"
                        >
                            <div className={classes2.label}>
                                {progress === 0 && loaded && <TicketCheck size={20} color="white" />}
                                {progress !== 0 ? 'Enviando...' : loaded ? ' Boletos Confirmados' : 'Enviar Confirmación'}
                            </div>
                            {progress !== 0 && <Progress value={progress} className={classes2.progress} />}
                        </Button>
                    </div>
                )}
            </View>
        </div>
    );
}

const styles = StyleSheet.create({
    form: {
        backgroundColor: '#fff',
        borderRadius: 20,
        padding: 15,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 10 },
        shadowOpacity: 0.1,
        shadowRadius: 15,
        minWidth: '300px',
        maxWidth: '90vw',
        elevation: 5,
        marginTop: 20,
        marginBottom: 20
    }
});